import { API_URL } from "../../components/common/Constants";
import {
  IStandardAPIResponse,
  IAdmin,
  ICemCustomer,
  IAssignCemCustomer,
} from "../../vm";
import { httpClient, handleErrorResp, getToken } from "../UtilService";

export async function getAllDataCenterManagers(
  datacenterId?: string
): Promise<IStandardAPIResponse<Array<IAdmin>>> {
  try {
    let res = await httpClient<Array<IAdmin>>(`datacenter-admins`, "GET", {
      datacenterId,
    });
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getAllAdmins(
  data: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`admins`, "GET", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function addDataCenterManager(
  data: IAdmin
): Promise<IStandardAPIResponse<IAdmin>> {
  try {
    let res = await httpClient<IAdmin>(`datacenter-admins`, "PUT", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function updateDataCenterManager(
  data: IAdmin
): Promise<IStandardAPIResponse<IAdmin>> {
  try {
    let res = await httpClient<IAdmin>(
      `datacenter-admins/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateDataCenterManagerPassword(
  userId: string,
  newPassword: string
): Promise<IStandardAPIResponse<string | undefined>> {
  try {
    let res = await httpClient<string | undefined>(
      `datacenter-admins/${userId}/password`,
      "PATCH",
      { newPassword: newPassword }
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function deleteDataCenterManager(
  data: IAdmin
): Promise<IStandardAPIResponse<IAdmin>> {
  try {
    let res = await httpClient<IAdmin>(
      `datacenter-admins/${data._id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function getCemCustomers(obj: {
  userId: string;
  search?: string;
}): Promise<IStandardAPIResponse<Array<ICemCustomer>>> {
  try {
    let res = await httpClient<Array<ICemCustomer>>(
      `cem-customers`,
      "GET",
      obj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function assignCemCustomers(
  data: IAssignCemCustomer[]
): Promise<IStandardAPIResponse<ICemCustomer>> {
  try {
    let res = await httpClient<ICemCustomer>(
      `cem-multi-customers`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function deleteCemCustomers(
  data: ICemCustomer
): Promise<IStandardAPIResponse<ICemCustomer>> {
  try {
    let res = await httpClient<ICemCustomer>(
      `cem-customers/${data._id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function getUsersExcel(): Promise<Response> {
  try {
    let res = await fetch(`${API_URL}export-users`, {
      method: "GET",
      credentials: "include", // Enable credentials for CORS
      headers: { at: getToken() },
    });
    return res;
  } catch (err: any) {
    return err;
  }
}

export async function getCemAssignToACustomer(
  customerIds: string[]
): Promise<IStandardAPIResponse<{ [key: string]: IAdmin[] }>> {
  try {
    let res = await httpClient<{ [key: string]: IAdmin[] }>(
      `admins/cem`,
      "POST",
      { customerIds }
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

// forgot password
export async function requestForgotPasswordOtp(
  email: string
): Promise<IStandardAPIResponse<undefined>> {
  try {
    let res = await httpClient<undefined>(
      `auth/request-otp`,
      "POST",
      { email },
      false,
      "application/json; charset=utf-8",
      "", // No token needed for forgot password
      true // skipTokenRefresh = true for forgot password endpoints
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function validateForgotPasswordOtp(
  email: string,
  otp: string
): Promise<IStandardAPIResponse<{ normalUser: boolean }>> {
  try {
    let res = await httpClient<{ normalUser: boolean }>(
      `auth/verify-otp`,
      "POST",
      {
        email,
        otp,
      },
      false,
      "application/json; charset=utf-8",
      "", // No token needed for forgot password
      true // skipTokenRefresh = true for forgot password endpoints
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function resetForgotPassword(
  email: string,
  otp: string,
  newPassword: string
): Promise<IStandardAPIResponse<undefined>> {
  try {
    let res = await httpClient<undefined>(
      `auth/reset-password`,
      "POST",
      {
        email,
        otp,
        newPassword,
      },
      false,
      "application/json; charset=utf-8",
      "", // No token needed for forgot password
      true // skipTokenRefresh = true for forgot password endpoints
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
